var React = require('react');

function QuoteIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"41","cy":"40.411","r":"40.088","fill":"#2A87F5","key":0}),React.createElement("path",{"d":"M40.457 37.877c0-5.425-4.397-9.822-9.822-9.822-5.425 0-9.362 4.245-9.822 9.65-.701 8.249 5.564 15.154 13.17 17.35a9.814 9.814 0 01-4.703-7.465c.444.064.893.107 1.353.107a9.82 9.82 0 009.824-9.82zM61.205 37.877c0-5.425-4.397-9.822-9.822-9.822-5.425 0-9.362 4.245-9.823 9.65-.7 8.249 5.564 15.154 13.173 17.35a9.813 9.813 0 01-4.703-7.465c.443.064.894.107 1.353.107 5.424.002 9.822-4.396 9.822-9.82z","fill":"#fff","key":1})]);
}

QuoteIcon.defaultProps = {"width":"82","height":"82","viewBox":"0 0 82 82","fill":"none"};

module.exports = QuoteIcon;

QuoteIcon.default = QuoteIcon;
